import './styles.css'

export default function TituloDaPagina(props) {
  return <h1 className="tituloDaPagina">{props.children}</h1>;
}
